import Dashboard from ".";

export const dashboardRoutes = (data) => [
  {
    path: "/:lang/admin",
    title: "dashboard",
    layout: "admin",
    routeType: "admin",
    component: Dashboard,
  },
  {
    path: "/:lang/admin/dashboard",
    title: "dashboard",
    layout: "admin",
    routeType: "admin",
    component: Dashboard,
  },
];
